import { toJsonDate, randomString } from '../../util';
import _ from 'lodash';

const REGEX_AUG_INDEX_ACCESS = /^\\\$(0|[1-9]\d*)$/;

export default {
	methods:
	{
		getValuetype( value )
		{
			let valuetype = typeof value;
			switch( valuetype )
			{
				case 'boolean':
				case 'string':
					return valuetype;
				case 'number':
					if( !isFinite( value ) )
						throw new Error( "Number value is Infinite or NaN" );
					return valuetype;
				case 'object':
					if( value === null )
						return 'null';
					else if( Array.isArray( value ) )
						return 'array';
					else if( value.$date && Object.keys( value ).length === 1 )
						return 'date';
					else if( value.hasOwnProperty( '$ref' ) )
					{
						for( let key in value )
							if( key !== '$ref' && key !== '$source' )
								throw new Error( `Reference ($ref) value has invalid property: ${key}` );
						return 'reference';
					}
					else
						return 'object';
				default:
					throw new Error( "Unsupported type: "+ valuetype );
			}
		},
		editorDataToObject( data, augmentation = false )
		{
			let result = { };
			
			if( data.$id && data.$id.type === "string.short" && data.$id.value )
				result.$id = data.$id.value;
			else if( data.$id && data.$id.type === "number" && data.$id.value )
			{
				const numId = Number( data.$id.value );
				if( ""+ numId )
					result.$id = numId;
			}	
			if( data.$schema && data.$schema.type !== "none" )
			{
				if( !augmentation && data.$schema.value )
					result.$schema = data.$schema.value;
				else if( augmentation && data.$schema.aug && data.$schema.aug.value )
					result.$schema = data.$schema.aug.value;
				
			}

			let fields = data.fields;
			if( Array.isArray( fields ) )
				for( let i=0; i < fields.length; i++ )
				{
					const f = fields[i];
					const fieldName = f.fieldname;
					if( fieldName === "" )
						continue;	// Skip empty fields!
					
					if( f.inactive && ( !augmentation || !f.aug ) )
						continue;

					if( result.hasOwnProperty( fieldName ) )
					{
						console.warn( "Duplicate field name '"+ fieldName +"' found within a single object!" );
						alert( "Duplicate field name '"+ fieldName +"' found within a single object. Please change this field-name to something unique before you continue." );
						f.invalid = true;
						return;
					}
					const value = this.editorGetValueFromField( f, augmentation );
					if( typeof value !== "undefined" )
						result[fieldName] = value;
				}
			return result;
		},
		editorValuesToArray( values, augmentation = false )
		{
			if( augmentation )
			{
				const result = { };
				for( let i=0; i < values.length; i++ )
				{
					const value = this.editorGetValueFromField( values[i], true );
					if( typeof value !== "undefined" )
						result["\\$"+i] = value;
				}
				if( Object.keys( result ).length > 0 )
					return result;
				return undefined;
			}
			else	// augmentation = false - FULL ARRAY REPLACEMENT!
			{
				let result = [];
				for( let i=0; i < values.length; i++ )
				{
					let value = this.editorGetValueFromField( values[i], false );
					if( typeof value !== "undefined" )
						result.push( value );
				}
				return result;
			}
		},
		editorGetValueFromField( field, augmentation = false )
		{
			const aug = field.aug || { };
			const type = ( augmentation ? ( aug.type || field.type ) : field.type );
			const value = ( augmentation ? aug.value : field.value );
			const values = ( augmentation ? aug.values : field.values );

			if( augmentation && aug.remove === true )	// Handle the "hide" augmentation case.
				return { "\\$delete" : true };

			switch( type )
			{
				case "string.short":
				case "string.block":
				case "string.html":
					return ( typeof value === 'undefined' ? value : ""+ value );
				case "number":
					if( !isFinite( Number( value ) ) )
						return undefined;
					return Number( value );
				case "array":
					if( augmentation && field.aug )
						return this.editorValuesToArray( values || [], false );	// NOT augmented any further!
					return this.editorValuesToArray( field.values || [], augmentation );	// Default case.. might be augmented further.
				case "object":
					if( augmentation && field.aug )
					{
						const newObj = this.editorDataToObject( field.aug, false );
						newObj['\\$new'] = true;
						return newObj;
					}
					return this.editorDataToObject( field, augmentation );
				case "date":
					try {
						let jsonDate = toJsonDate( value );
						if( typeof jsonDate.$date !== 'number' || !Number.isFinite( jsonDate.$date ) )
							throw new Error( "Invalid date" );
						return jsonDate;
					} catch( err ) {
						return console.warn( "Failed to process date from value: "+ value );
					}
				default:
					return value;
			}
		},
		objectToEditorData( object, schemas, augmentation )
		{
			const aug = augmentation || { };

			let editorData = { type : "object", $schema : { type : "none", structured : "optional", inactive : true }, $id : { type : "auto" }, fields : [] };
			
			if( object.$id )
			{
				if( typeof object.$id === 'string' )
				{
					editorData.$id.type = "string.short";
					editorData.$id.value = object.$id;
				}
				else if( typeof object.$id === 'number' && isFinite( object.$id ) )
				{
					editorData.$id.type = 'number';
					editorData.$id.value = object.$id;
				}
				else
					throw new Error( "Invalid object $id: "+ object.$id +" (Type: "+ typeof object.$id +")" );
				editorData.$id._htmlId = randomString( );
			}
			// else
			// 	console.warn( `NO OBJECT $id` );

			let schema;

			if( object.$schema )
			{
				schema = schemas[object.$schema];
				if( !schema )
					console.warn( `SCHEMA [${object.$schema}] NOT FOUND!` );
				
				if( typeof object.$schema !== 'string' )
					throw new Error( "Invalid object $schema: "+ object.$schema +" (Type: "+ typeof object.$schmea +")" );

				editorData.$schema.type = "string.short";
				editorData.$schema.value = object.$schema;
				editorData.$schema._htmlId = randomString( );
				delete editorData.$schema.inactive;

				if( schema && augmentation && augmentation.$schema )
				{
					const augSchema = schemas[augmentation.$schema];
					if( !augSchema )
						console.warn( `Augmented schema [${augmentation.$schema}] NOT FOUND! (Ignoring)` );
					else if( !augSchema.$id.startsWith( schema.$id ) )
						console.warn( `Augmented schema [${augmentation.$schema}] does not derive from source schema [${schema.$id}] (Ignoring)` );
					else
					{
						schema = augSchema;
						editorData.$schema.aug = {
							type : editorData.$schema.type,
							value : augmentation.$schema
						};
					}
				}
			}
			
			

			// First, process all source object fields and corresponding augmentations (if/when any).
			const newSourceFieldsLookup = { };
			const processedFieldsLookup = { };

			for( let f in object )
			{
				if( f.charAt(0) === '$' || f.startsWith( '\\$' ) )
				{
					//console.log( "Skipping system field: "+ f );
					continue;	// Skip in this process.
				}
				
				let newField;
				try {
					newField = this.valueToEditorItem( object[f], schemas, false, aug[f] );
					if( typeof aug[f] !== 'undefined' )
					{
						const augValue = this.valueToEditorItem( aug[f], schemas, true );	// Could be undefined.
						if( typeof augValue !== 'undefined' )
							newField.aug = augValue;
					}
				} catch( err ) { console.error( "Issue with field '"+ f +"'. "+ err.message ); }

				let fieldDefinition;
				if( schema )
				{
					fieldDefinition = schema.fieldsLookup[f];
					if( !fieldDefinition )
					{
						if( newField.aug )
							newField.aug.remove = true;
						else if( augmentation )
							newField.aug = { remove : true, lock : true };
						else
						{
							console.log( `Skipping source field [${f}] because it is not part of the schema [${schema.$id}]!` );
							continue;	// If not augmented, just skip the field which is not found in the schema structure!
						}
						console.log( `Hiding field [${f}] through augmentation, because it is not part of the schema [${schema.$id}]!` );
					}
					
				}

				newField.fieldname = f;
				if( fieldDefinition )
					newField.structured = ( fieldDefinition.required ? 'required' : 'optional' );
				editorData.fields.push( newField );
				newSourceFieldsLookup[f] = newField;
				processedFieldsLookup[f] = true;
			}

			// Second, process all augmentations that do not have corresponding source object fields.
			for( let f in aug )
			{
				// console.log( "*** PROCESSING AUG OBJECT FEILD: ", f, aug[f] );
				if( object.hasOwnProperty( f ) || typeof aug[f] === 'undefined' )
					continue;	// Already processed with source object..
			
				let fieldDefinition;
				if( schema )
				{
					if( !schema.fieldsLookup.hasOwnProperty( f ) )
					{
						console.log( `Skipping augmentation field [${f}] because it is not part of the schema [${schema.$id}]!` );
						continue;
					}
					fieldDefinition = schema.fieldsLookup[f];
				}


				if( REGEX_AUG_INDEX_ACCESS.test( f ) )
				{
					console.warn( `Warning: found an array-index-access field [${f}] in augmentation. Ignoring, but LOOK INTO THIS!`
						+` Augmenting an object here, NOT an array... So, ignoring should be OK; maybe this object just USED TO be an array when first augmented?` );
					continue;
				}

				if( f.charAt(0) === '$' )
				{
					console.warn( `Warning: found a system field [${f}] in augmentation. Ignoring.` );
					continue;
				}

				let newField;
				try {
					newField = { fieldname : f, type : "new", _htmlId : randomString( ), aug : this.valueToEditorItem( aug[f], schemas, false ) };
				} catch( err ) { console.error( "Issue with field '"+ f +"'. "+ err.message ); }
				if( fieldDefinition )
					newField.structured = ( fieldDefinition.required ? 'required' : 'optional' );
				editorData.fields.push( newField );
				processedFieldsLookup[f] = true;
			}

			if( schema )
				for( let f in schema.fieldsLookup )
				{
					const field = schema.fieldsLookup[f];
					if( field.parent )
						continue;
					if( !processedFieldsLookup[f] )
					{
						const structured = ( field.required ? "required" : "optional" );
						let type = ( field.valuetype && field.valuetype != 'string' ? field.valuetype : "string.short" );
						const newField = { fieldname : f, type, structured, _htmlId : randomString( ) };
						if( !field.required )
							newField.inactive = true;
						editorData.fields.push( newField );
					}
				}
			return editorData;
		},

		valueToEditorItem( value, schemas, aug = false, augValue )
		{
			let item = { };
			switch( typeof value )
			{
				case "string":
					item.type = 'string.short';
					if( value.length > 50 || value.indexOf( '\n' ) >= 0 )
					{
						if( value.startsWith( "<!-- html -->" ) )
							item.type = 'string.html';
						else
							item.type = 'string.block';
					}
					item.value = value;
					break;
				case "number":
					if( !isFinite( value ) )
						throw new Error( "Invalid number value: "+ value );
					item.type = 'number';
					item.value = value;
					break;
				case "boolean":
					item.type = 'boolean';
					item.value = value;
					break;
				case "object":
					if( value === null )
						item.type = 'null';
					else if( Array.isArray( value ) )
					{
						item.type = "array";
						item.values = [ ];
						for( let i=0; i < value.length; i++ )
						{
							let itemAugValue = undefined;	// To be explicit.
							let indexAugValue = undefined;

							// If the aug-value has this array index replacement, then prepare it as a special pre-computed EDITOR-ITEM aug.
							if( augValue && typeof augValue === 'object' && typeof augValue['\\$'+i] !== 'undefined' )
							{
								indexAugValue = augValue['\\$'+i];
								if( this.getValuetype( indexAugValue ) !== 'object' || indexAugValue.$new )	// Only if non-$new object, JUST to make sure.
									itemAugValue = this.valueToEditorItem( indexAugValue, schemas, true );	// Will be undefined, if non-$new object aug value.
							}

							try {
								// Create the source value item, sending in the aug, in case it's a valid object or array-index augmenter/updater.
								const augItemValue = this.valueToEditorItem( value[i], schemas, false, indexAugValue );	// The [indexAugValue] will only be considered when a non-$new object.
								
								if( typeof augItemValue === 'undefined' )
									console.warn( "augItemValue is UNDEFINED!" );
								
								// Add it as an aug, only if it is a valid REPLACEMENT augmentation (terminal/array value or $new object)
								if( typeof itemAugValue !== 'undefined' )
									augItemValue.aug = itemAugValue;
								
								item.values.push( augItemValue );
							} catch( err ) {
								throw new Error( "Issue with value at array index ["+ i +"]. "+ err.message );
							}

						}
					}
					else if( value.$date && Object.keys( value ).length === 1 )
					{
						item.type = "date";
						item.value = new Date( value.$date );
					}
					else if( value.hasOwnProperty( '$ref' ) )
					{
						for( let key in value )
							if( key !== '$ref' && key !== '$source' )
								throw new Error( `Reference ($ref) value has invalid property: ${key}` );
						item.type = "reference";
						item.value = _.cloneDeep( value );
					}
					else if( !aug || value['\\$new'] === true )
					{
						try {	
							augValue = ( this.getValuetype( augValue ) === 'object' ? augValue : undefined );	// If it's not an object, don't pass it.
						} catch( err ) { augValue = undefined; }
						item = this.objectToEditorData( value, schemas, augValue );	// augValue will only exist when !aug.
					}
					else if( aug && value['\\$delete'] === true )
					{
						item.type = "";
						item.remove = true;
					}
					else
						return undefined;	// Just to be explicit.. returning nothing.
					break;
				default:
					break;
			}
			if( item && typeof item === 'object' && !Array.isArray( item ) )
				item._htmlId = randomString( );
			return item;
		},

		addEditorField( sourceFields, augmenting = false )
		{
			let htmlId = randomString( );
			let newField;
			if( augmenting )
				newField = { fieldname : "", type : "new", _htmlId : htmlId, aug : { type : "string.short", value : "" } };
			else
				newField = { fieldname : "", type : "string.short", value : "", _htmlId : htmlId };
			this.$set( sourceFields, sourceFields.length, newField );

			this.$nextTick( function( ) {
				document.getElementById( htmlId ).focus( );
			} );
		},
	}
};


// WEBPACK FOOTER //
// ./src/components/mixins/objectEditing.js